import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert } from '@mui/material';
import authService from '../services/authService';

interface Props {
  open: boolean;
  onClose: () => void;
}

const PasswordResetDialog2: React.FC<Props> = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSend = async () => {
    setError(null);
    setSuccess(null);
    if (!email) {
      setError('E-Mail erforderlich');
      return;
    }
    setLoading(true);
    try {
      await authService.requestPasswordReset(email.trim());
      setSuccess('Wenn die E-Mail existiert und eine WhatsApp-Nummer hinterlegt ist, wurde ein temporäres Passwort gesendet.');
    } catch (e: any) {
      const msg = e?.error || e?.message || 'Fehler beim Reset.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Passwort vergessen</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <TextField
          label="E-Mail"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
        <Button onClick={handleSend} disabled={loading} variant="contained">Senden</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordResetDialog2;
